const statementsDE = {
    "view": {
        "table": {
            "title": "Ihre Abrechnungsliste",
            "column": {
                "type": "Typ",
                "year": "Jahr",
                "month": "Monat",
                "issue_year": "Ausg. Jahr",
                "issue_month": "Ausg. Monat",
                "description": "Beschreibung",
                "amount": "Betrag",
                "status": "Status",
                "details": "Details",
                "overview": "Übersicht"
            },
            "placeholder": {
                "search": "Suche..."
            },
            "label": {
                "status_open": "Offen",
                "status_paid": "Bezahlt",
                "type_licensing": "Lizenzierung",
                "type_regular": "Regulär",
                "type_audio_mastering_services": "Audio Mastering - Dienstleistungen",
                "type_vinyl_earnings": "Vinyl Einnahmen",
                "type_offset": "Offset",
                "type_not_known": "Unbekannt",
                "month_january": "Januar",
                "month_february": "Februar",
                "month_march": "März",
                "month_april": "April",
                "month_may": "Mai",
                "month_june": "Juni",
                "month_july": "Juli",
                "month_august": "August",
                "month_september": "September",
                "month_october": "Oktober",
                "month_november": "November",
                "month_december": "Dezember"
            },
            "button": {
                "download": "Herunterladen",
                "exportCsv": "CSV exportieren"
            }
        },
        "message": {
            "subscriptionUpgrade": "Ihr aktueller Abonnementplan unterstützt diese Funktion nicht. Bitte <1>aktualisieren</1> Sie Ihren Abonnementplan, um diese Funktion zu nutzen.",
            "subscriptionExpired": "Ihr Abonnement ist abgelaufen. Bitte <1>setzen</1> Sie Ihr Abonnement fort, um diese Funktion zu nutzen.",
            "noAccess": "Sie haben keinen Zugriff auf dieses Modul, bitte kontaktieren Sie das Support-Team für weitere Informationen."
        }
    }
};

export default statementsDE;